import Form from './Form';

export default class OrgsForm extends Form {
    templateId() {
        return '#orgsFormTemplate';
    }

    data() {
        return '/dashboard/profile/ajax/orgs/get';
    }
}
